// client/src/layouts/UserLayout.js
import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { io } from "socket.io-client";
import { useAuth } from "../context/AuthContext";
import api from "../api/axiosInstance";

import UserTopBar from "../components/UserTopBar";
import UserSidebar from "../components/UserSidebar";

export default function UserLayout() {
  const { authUser, setAuthUser } = useAuth();
  const location = useLocation();

  /* ================= SOCKET CONNECTION ================= */
  useEffect(() => {
    if (!authUser?.user?._id) return;

    const socket = io("https://api.smsorbit.in", {
      transports: ["websocket"],
    });

    socket.emit("join", authUser.user._id);

    // 🔥 Wallet live update from backend
    socket.on("wallet_update", ({ balance }) => {
      setAuthUser((prev) => ({
        ...prev,
        user: { ...prev.user, balance },
      }));
    });

    // 🔔 Order updates
    socket.on("order_update", () => {
      api.get("/user/notifications").catch(() => {});
    });

    return () => {
      socket.disconnect();
    };
  }, [authUser, setAuthUser]);

  /* ================= MANUAL WALLET UPDATE EVENT ================= */
  useEffect(() => {
    const handler = (e) => {
      setAuthUser((prev) => ({
        ...prev,
        user: { ...prev.user, balance: e.detail.balance },
      }));
    };

    window.addEventListener("wallet_updated", handler);

    return () => {
      window.removeEventListener("wallet_updated", handler);
    };
  }, [setAuthUser]);

  return (
    <div className="min-h-screen flex bg-[#0b0f17] text-white">
      {/* SIDEBAR */}
      <UserSidebar currentPath={location.pathname} />

      {/* MAIN CONTENT */}
      <div className="flex-1 ml-64 flex flex-col">
        {/* TOP BAR */}
        <div className="sticky top-0 z-40">
          <UserTopBar />
        </div>

        {/* PAGE CONTENT */}
        <main className="flex-1 overflow-y-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
